import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'ami-option-launch-select-dropdown',
  templateUrl: './ami.dropdown.launch.component.html',
  styleUrls: ['./ami.dropdown.launch.component.css'],
})
export class AMILaunchDropdownComponent implements OnInit, OnDestroy {
  @Input() ami: any;
  ngOnInit(): void {}

  constructor() {}

  ngOnDestroy(): void {}
}
